import { render, staticRenderFns } from "./CampaignHistoryTranscription.vue?vue&type=template&id=c55fb652&scoped=true&"
import script from "./CampaignHistoryTranscription.vue?vue&type=script&lang=js&"
export * from "./CampaignHistoryTranscription.vue?vue&type=script&lang=js&"
import style0 from "./CampaignHistoryTranscription.vue?vue&type=style&index=0&id=c55fb652&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55fb652",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {
  VProgressCircular,
})
